module.exports = __webpack_public_path__ + "img/ic_next_active_dark_grey.19af1c41.svg";